(function(){
  if (window.__GwaQuickbuyReady) return;
  const root = document.getElementById('gwa-qb');
  if(!root) return;
  // The intent loader waits for the stylesheet before evaluating this module.
  root.hidden = false;

  const elImg = root.querySelector('[data-gwa-qb-img]');
  const elTitle = root.querySelector('[data-gwa-qb-title]');
  const elSub = root.querySelector('[data-gwa-qb-sub]');
  const elSwatches = root.querySelector('[data-gwa-qb-swatches]');
  const elPriceNow = root.querySelector('[data-gwa-qb-price-now]');
  const elPriceWas = root.querySelector('[data-gwa-qb-price-was]');
  const elPriceSave = root.querySelector('[data-gwa-qb-price-save]');
  const elUnit = root.querySelector('[data-gwa-qb-unit]');
  const elQtyWrap = root.querySelector('[data-gwa-qb-qtywrap]');
  const elQty = root.querySelector('[data-gwa-qb-qty]');
  const btnMinus = root.querySelector('[data-gwa-qb-qtyminus]');
  const btnPlus = root.querySelector('[data-gwa-qb-qtyplus]');
  const btnAdd = root.querySelector('[data-gwa-qb-add]');

  const productCache = new Map();
  const inflight = new Map();
  const swatchMapCache = new Map();

  let state = { card:null, product:null, swmap:null, selected:{}, variant:null, qty:1 };

  function slugify(s){
    return String(s||'')
      .toLowerCase()
      .trim()
      .replace(/[&/,.+]/g,' ')
      .replace(/\s+/g,'-')
      .replace(/-+/g,'-');
  }

  function isColorOptionName(name){
    const n = String(name || '').trim().toLowerCase();
    return n.includes('farbe') || n.includes('color') || n.includes('colour');
  }

  function optionNamesMatch(metaName, optionName){
    const meta = String(metaName || '').trim().toLowerCase();
    const opt = String(optionName || '').trim().toLowerCase();
    if(!meta) return isColorOptionName(opt);
    if(meta === opt) return true;
    return isColorOptionName(meta) && isColorOptionName(opt);
  }

  function extractCssUrl(value){
    const v = String(value || '');
    const match = v.match(/url\(["']?(.*?)["']?\)/i);
    return match ? match[1] : '';
  }

  function optNameToString(x){
    if(typeof x === 'string') return x;
    if(x && typeof x === 'object'){
      if(typeof x.name === 'string') return x.name;
      if(typeof x.option_name === 'string') return x.option_name;
      if(typeof x.title === 'string') return x.title;
    }
    return String(x || '');
  }

  function getOptionNames(product){
    const raw = (product && product.options) ? product.options : [];
    return raw.map(optNameToString);
  }

  function normalizeMoneyFormat(fmt){
    let s = String(fmt || '');
    s = s.replace(/\\u0026nbsp;|&nbsp;/g, '\u00A0');
    s = s.replace(/<\/?[^>]+>/g, '');
    return s.trim();
  }

  function getMoneyFormat(){
    const raw =
      (window.gwaMoneyFormat) ||
      (window.theme && (theme.moneyFormat || theme.money_format || theme.money_with_currency_format)) ||
      (window.Shopify && (Shopify.money_format || Shopify.money_with_currency_format)) ||
      '{{amount}}';

    return normalizeMoneyFormat(raw);
  }

  function formatMoney(cents){
    const v = (cents == null) ? 0 : Number(cents);
    if(v === 0) return (window.gwaStrings && window.gwaStrings.gwa_quickbuy && window.gwaStrings.gwa_quickbuy.free) || 'Gratis';
    const fmt = getMoneyFormat();

    try{
      if(window.Shopify && typeof Shopify.formatMoney === 'function'){
        return Shopify.formatMoney(v, fmt);
      }
    }catch(e){}

    try{
      return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        .format((v || 0) / 100) + '\u00A0€*';
    }catch(e){}

    return ((v || 0) / 100).toFixed(2) + ' €*';
  }

  function formatNumberDE(n, digits){
    const v = Number(n);
    if(!isFinite(v)) return '';
    try{
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }).format(v);
    }catch(e){
      return v.toFixed(digits);
    }
  }

  function sizedShopifyImg(url, size){
    if(!url) return '';
    const parts = String(url).split('?');
    const clean = parts[0];
    const qs = parts[1] ? '?' + parts[1] : '';
    if(clean.includes(`_${size}x`)) return clean + qs;
    return clean.replace(/(\.(png|jpe?g|webp|avif))$/i, `_${size}x$1`) + qs;
  }

  function preload(url){
    if(!url) return;
    const i = new Image();
    i.decoding = 'async';
    i.loading = 'eager';
    i.src = url;
  }

  function updateViewportHeight(){
    root.style.setProperty('--gwa-qb-vh', `${window.innerHeight}px`);
  }

  function open(){
    updateViewportHeight();
    root.classList.add('is-open');
    root.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow='hidden';
  }

  function close(){
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow='';
    state = { card:null, product:null, swmap:null, selected:{}, variant:null, qty:1 };
    elSwatches.innerHTML='';
    if(elUnit){
      elUnit.style.display = 'none';
      elUnit.innerHTML = '';
    }
    qtySet(1);
  }

  root.addEventListener('click', (e)=>{
    if(e.target && e.target.closest('[data-gwa-qb-close]')) close();
  });
  document.addEventListener('keydown', (e)=>{
    if(e.key==='Escape' && root.classList.contains('is-open')) close();
  });
  window.addEventListener('resize', updateViewportHeight, { passive: true });
  window.addEventListener('orientationchange', updateViewportHeight, { passive: true });

  function parseSwMap(card, fetched){
    const s = card.querySelector('script[data-swatch-map]');
    let map = {};
    if(s){
      try{ map = JSON.parse(s.textContent || '{}') || {}; }catch(e){ map = {}; }
    }
    if(fetched) map = Object.assign({}, fetched, map);

    const rendered = readRenderedCardSwatches(card);
    if(rendered){
      map.by_variant_id = mergeVariantSwatchLists(rendered.by_variant_id, map.by_variant_id);
      map.variant_images = Object.assign({}, rendered.variant_images || {}, map.variant_images || {});
      if(rendered.initial_image && !map.initial_image) map.initial_image = rendered.initial_image;
    }

    return map;
  }

  function mergeVariantSwatchLists(rendered, encoded){
    const result = {};
    const keys = new Set(Object.keys(rendered || {}).concat(Object.keys(encoded || {})));

    keys.forEach((key)=>{
      result[key] = []
        .concat(rendered && rendered[key] ? rendered[key] : [])
        .concat(encoded && encoded[key] ? encoded[key] : []);
    });

    return result;
  }

  function readRenderedCardSwatches(card){
    if(!card) return null;

    const map = { by_variant_id: {}, variant_images: {}, initial_image: '' };
    const mainImg = card.querySelector('[data-card-main-image]');
    if(mainImg){
      map.initial_image = mainImg.getAttribute('data-default-src') || mainImg.currentSrc || mainImg.src || '';
    }

    card.querySelectorAll('.card__swatches [data-gwa-swatch]').forEach((swatch)=>{
      const variantId = swatch.getAttribute('data-variant-id');
      if(!variantId) return;

      const wrap = swatch.closest('.card__swatches');
      const optName = wrap ? (wrap.getAttribute('data-option-name') || '') : '';
      const label = swatch.getAttribute('title') || swatch.getAttribute('aria-label') || '';
      const dot = swatch.querySelector('.card__swatch-img');
      const bgImage = dot ? extractCssUrl(dot.style.backgroundImage) : '';
      const bgColor = dot ? (dot.style.backgroundColor || '') : '';
      const variantImg = swatch.getAttribute('data-variant-img') || '';

      if(variantImg) map.variant_images[String(variantId)] = variantImg;
      if(!map.by_variant_id[String(variantId)]) map.by_variant_id[String(variantId)] = [];

      map.by_variant_id[String(variantId)].push({
        option_name: optName,
        value_key: label,
        label,
        short_label: label,
        aliases: label,
        swatch_type: bgImage ? 'image' : (bgColor ? 'color' : ''),
        swatch_image_url: bgImage,
        swatch_color: bgColor
      });
    });

    return map;
  }

  function findSwatchMetaAny(swmap, optionName, optionValue){
    if(!swmap || !swmap.by_variant_id) return null;

    const on = String(optionName||'').trim().toLowerCase();
    const ov = String(optionValue||'').trim().toLowerCase();
    const ovSlug = slugify(ov);

    const by = swmap.by_variant_id;
    for(const vid in by){
      const list = by[vid] || [];
      for(const mo of list){
        const mOn = String(mo.option_name||'').trim().toLowerCase();
        if(!optionNamesMatch(mOn, on)) continue;

        const key = String(mo.value_key||'').trim().toLowerCase();
        const label = String(mo.label||'').trim().toLowerCase();
        const aliases = String(mo.aliases||'').toLowerCase();

        const keySlug = slugify(key);
        const labelSlug = slugify(label);

        let matched = false;
        if(keySlug && keySlug === ovSlug) matched = true;
        else if(labelSlug && labelSlug === ovSlug) matched = true;
        else if(aliases && aliases.includes(ov)) matched = true;
        else if(aliases && aliases.includes(ovSlug)) matched = true;

        if(matched) return mo;
      }
    }
    return null;
  }

  function getVariantImageFromSwmap(swmap, variantId){
    if(!swmap || !swmap.variant_images || variantId == null) return '';
    return swmap.variant_images[String(variantId)] || '';
  }

  function getVariantSwatchMeta(swmap, variantId, optionName, optionValue){
    if(!swmap || !swmap.by_variant_id || variantId == null) return null;

    const list = swmap.by_variant_id[String(variantId)] || [];
    if(!list.length) return null;

    const on = String(optionName||'').trim().toLowerCase();
    const ov = String(optionValue||'').trim().toLowerCase();
    const ovSlug = slugify(ov);
    let fallback = null;
    let exact = null;

    for(const mo of list){
      const mOn = String(mo.option_name||'').trim().toLowerCase();
      if(!optionNamesMatch(mOn, on)) continue;
      if(!fallback || ((!fallback.swatch_image_url && !fallback.swatch_color) && (mo.swatch_image_url || mo.swatch_color))) fallback = mo;

      const key = String(mo.value_key||'').trim().toLowerCase();
      const label = String(mo.label||'').trim().toLowerCase();
      const aliases = String(mo.aliases||'').toLowerCase();
      const keySlug = slugify(key);
      const labelSlug = slugify(label);

      if((keySlug && keySlug === ovSlug) ||
        (labelSlug && labelSlug === ovSlug) ||
        (aliases && (aliases.includes(ov) || aliases.includes(ovSlug)))){
        if(mo.swatch_image_url || mo.swatch_color) return mo;
        if(!exact) exact = mo;
      }
    }

    return exact || fallback;
  }

  function hasVisualSwatchMeta(swmap, optionName){
    if(!swmap || !swmap.by_variant_id) return false;

    const on = String(optionName||'').trim().toLowerCase();
    const by = swmap.by_variant_id;

    for(const vid in by){
      const list = by[vid] || [];
      for(const mo of list){
        const mOn = String(mo.option_name||'').trim().toLowerCase();
        if(!optionNamesMatch(mOn, on)) continue;
        if(mo.swatch_image_url || mo.swatch_color) return true;
      }
    }

    return false;
  }

  function buildOptionsFromProduct(product){
    const opts = getOptionNames(product);
    const variants = product.variants || [];
    const valuesByOpt = {};
    opts.forEach((name)=> valuesByOpt[name]=[]);

    for(const v of variants){
      const vopts = v.options || [];
      vopts.forEach((val, idx)=>{
        const on = opts[idx];
        if(!on) return;
        if(!valuesByOpt[on].includes(val)) valuesByOpt[on].push(val);
      });
    }

    return { optionNames: opts, valuesByOpt };
  }

  function findVariant(product, selected){
    const names = getOptionNames(product);
    const variants = product.variants || [];
    for(const v of variants){
      let ok = true;
      for(let i=0;i<names.length;i++){
        const on = names[i];
        const want = selected[on];
        if(want == null){ ok=false; break; }
        if((v.options||[])[i] !== want){ ok=false; break; }
      }
      if(ok) return v;
    }
    return null;
  }

  function variantForOptionValue(product, optName, optVal, baseSelected){
    const names = getOptionNames(product);
    const variants = product.variants || [];
    const idx = names.indexOf(optName);
    if(idx === -1) return null;

    for(const v of variants){
      if((v.options||[])[idx] !== optVal) continue;
      let ok = true;
      for(let i=0;i<names.length;i++){
        if(i === idx) continue;
        const on = names[i];
        const base = baseSelected[on];
        if(base == null) continue;
        if((v.options||[])[i] !== base){ ok=false; break; }
      }
      if(ok) return v;
    }

    for(const v of variants){
      if((v.options||[])[idx] !== optVal) continue;
      return v;
    }

    return null;
  }

  function setImageFromVariantOrProduct(v, p){
    let src = '';
    if(v) src = getVariantImageFromSwmap(state.swmap, v.id);
    if(!src && v && v.featured_image && v.featured_image.src) src = v.featured_image.src;
    if(!src && state.swmap && state.swmap.initial_image) src = state.swmap.initial_image;
    if(!src && p && p.featured_image) src = p.featured_image;

    const sized = sizedShopifyImg(src, 240) || src;
    if(sized){
      if(elImg.src !== sized){
        preload(sized);
        elImg.src = sized;
      }
      elImg.alt = (p && p.title) ? p.title : '';
    }
  }

  function discountPercent(price, compare){
    const p = Number(price||0);
    const c = Number(compare||0);
    if(!c || c <= p) return 0;
    return Math.round((1 - (p / c)) * 100);
  }

  function setPurchaseState(){
    const v = state.variant;
    const canBuy = !!v && v.available !== false;

    btnAdd.disabled = !canBuy;

    elQtyWrap.classList.toggle('is-disabled', !canBuy);
    btnMinus.disabled = !canBuy;
    btnPlus.disabled = !canBuy;

    if(!canBuy) qtySet(1);
  }

  function gramsFromVariant(v){
    if(!v) return 0;
    const w = Number(v.weight);
    if(!w || w <= 0) return 0;

    const unit = String(v.weight_unit || '').toLowerCase().trim();
    if(unit === 'kg') return w * 1000;
    if(unit === 'g' || unit === '') return w;
    if(unit === 'oz') return w * 28.349523125;
    if(unit === 'lb') return w * 453.59237;
    return w;
  }

  function updateUnitPrice(){
    if(!elUnit) return;

    const v = state.variant;
    if(!v){
      elUnit.style.display = 'none';
      elUnit.innerHTML = '';
      return;
    }

    const grams = gramsFromVariant(v);
    if(!grams){
      elUnit.style.display = 'none';
      elUnit.innerHTML = '';
      return;
    }

    const kg = grams / 1000;
    const priceCents = Number(v.price || 0);
    const centsPerKg = Math.round((priceCents * 1000) / grams);

    const kgText = formatNumberDE(kg, 2);
    const perKgHtml = formatMoney(centsPerKg);

    elUnit.style.display = '';
    const productContentLabel = (window.gwaStrings && window.gwaStrings.productContent) || 'Content';
    elUnit.innerHTML = `${productContentLabel}: ${kgText}\u00A0kg (${perKgHtml} / 1\u00A0kg)`;
  }

  function updatePrice(){
    const p = state.product;
    const v = state.variant;
    if(!p) return;

    const price = v ? v.price : p.price;
    const compare = v ? v.compare_at_price : p.compare_at_price;

    elPriceNow.innerHTML = formatMoney(price);

    const hasSale = compare && Number(compare) > Number(price);
    if(hasSale){
      elPriceWas.style.display = '';
      elPriceSave.style.display = '';

      elPriceWas.innerHTML = formatMoney(compare);

      const dp = discountPercent(price, compare);
      elPriceSave.textContent = dp ? (`-${dp}%`) : '';
      if(!dp) elPriceSave.style.display = 'none';
    }else{
      elPriceWas.style.display = 'none';
      elPriceSave.style.display = 'none';
      elPriceWas.innerHTML = '';
      elPriceSave.textContent = '';
    }

    updateUnitPrice();
  }

  function updateOptionHeaders(){
    const p = state.product;
    if(!p) return;

    elSwatches.querySelectorAll('[data-opt-wrap]').forEach(wrap=>{
      const optName = wrap.getAttribute('data-opt-name');
      const valuesCount = Number(wrap.getAttribute('data-opt-count') || 0);
      const selectedVal = state.selected[optName] || '';
      const head = wrap.querySelector('[data-opt-head]');
      if(head){
        head.innerHTML = '';
        const a = document.createElement('span');
        a.textContent = optName;

        const b = document.createElement('span');
        b.className = 'muted';
        b.textContent = `(${valuesCount})`;

        const sep = document.createElement('span');
        sep.className = 'sep';
        sep.textContent = ':';

        const c = document.createElement('span');
        c.setAttribute('data-gwa-qb-selected-value', '1');
        c.textContent = selectedVal || '';

        head.appendChild(a);
        head.appendChild(document.createTextNode(' '));
        head.appendChild(b);
        head.appendChild(document.createTextNode(' '));
        head.appendChild(sep);
        head.appendChild(document.createTextNode(' '));
        head.appendChild(c);
      }
    });
  }

  function updateSwatchStates(){
    const p = state.product;
    if(!p) return;

    elSwatches.querySelectorAll('[data-opt-wrap]').forEach(wrap=>{
      const optName = wrap.getAttribute('data-opt-name');
      wrap.querySelectorAll('button[data-opt-val]').forEach(btn=>{
        const val = btn.getAttribute('data-opt-val');
        const active = state.selected[optName] === val;
        btn.classList.toggle('is-active', !!active);

        const v = variantForOptionValue(p, optName, val, state.selected);
        const sold = v && v.available === false;
        btn.classList.toggle('is-soldout', !!sold);

        const x = btn.querySelector('[data-x]');
        if(x) x.style.display = sold ? '' : 'none';
      });
    });
  }

  function updateUI(){
    const p = state.product;
    if(!p) return;

    setImageFromVariantOrProduct(state.variant, p);
    updatePrice();
    setPurchaseState();
    updateOptionHeaders();
    updateSwatchStates();
  }

  function isTrivialSingleVariant(product){
    const opts = getOptionNames(product);
    const vars = product.variants || [];

    if(vars.length <= 1) return true;

    if(opts.length === 1 && String(opts[0]||'').toLowerCase() === 'title'){
      const uniq = new Set(vars.map(v => (v.options||[])[0]));
      if(uniq.size <= 1) return true;
    }

    return false;
  }

	  function computeOptionMode(swmap, optName, values){
	    if(hasVisualSwatchMeta(swmap, optName)) return 'image';

	    for(const val of values){
	      const mo = findSwatchMetaAny(swmap, optName, val);
	      if(mo && (mo.swatch_image_url || mo.swatch_color)) return 'image';
    }
    return 'text';
  }

  function orderedOptionNames(optionNames, valuesByOpt, swmap){
    const text = [];
    const img = [];
    for(const optName of optionNames){
      const values = valuesByOpt[optName] || [];
      const mode = computeOptionMode(swmap, optName, values);
      if(mode === 'text') text.push(optName);
      else img.push(optName);
    }
    return text.concat(img);
  }

  function renderSwatches(){
    const p = state.product;
    const swmap = state.swmap;
    elSwatches.innerHTML = '';

    if(!p || isTrivialSingleVariant(p)){
      state.variant = (p && p.variants && p.variants[0]) ? p.variants[0] : null;
      updateUI();
      return;
    }

    const { optionNames, valuesByOpt } = buildOptionsFromProduct(p);
    const namesOrdered = orderedOptionNames(optionNames, valuesByOpt, swmap);

    for(const optName of namesOrdered){
      const values = valuesByOpt[optName] || [];
      if(!values.length) continue;
      if(optionNames.length === 1 && String(optName||'').toLowerCase() === 'title') continue;

      if(state.selected[optName] == null){
        state.selected[optName] = values[0];
      }

      const wrap = document.createElement('div');
      wrap.className = 'gwa-qb__opt';
      wrap.setAttribute('data-opt-wrap', '1');
      wrap.setAttribute('data-opt-name', optName);
      wrap.setAttribute('data-opt-count', String(values.length));

      const head = document.createElement('div');
      head.className = 'gwa-qb__opt-head';
      head.setAttribute('data-opt-head','1');
      wrap.appendChild(head);

      const grid = document.createElement('div');
      grid.className = 'gwa-qb__swatch-grid';

      values.forEach(val=>{
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gwa-qb__swatch';
        btn.setAttribute('data-opt-val', val);
        btn.setAttribute('aria-label', val);
        btn.title = val;

        const vFor = variantForOptionValue(p, optName, val, state.selected);

	        const mo = getVariantSwatchMeta(swmap, vFor && vFor.id, optName, val) || findSwatchMetaAny(swmap, optName, val);
	        const imgUrl = mo && mo.swatch_image_url ? mo.swatch_image_url : '';
	        const col = mo && mo.swatch_color ? mo.swatch_color : '';

        const dot = document.createElement('span');
        dot.className = 'gwa-qb__swatch-dot';

        if(imgUrl){
          dot.style.backgroundImage = `url("${imgUrl}")`;
        }else if(col){
          dot.style.backgroundColor = col;
        }else{
          btn.classList.add('gwa-qb__swatch--text');
          dot.classList.add('gwa-qb__swatch-dot--text');
          const s = String(val || '');
          dot.textContent = s;
        }
        btn.appendChild(dot);

        const sold = vFor && vFor.available === false;
        const x = document.createElement('span');
        x.className = 'gwa-qb__swatch-x';
        x.setAttribute('data-x','1');
        x.textContent = '×';
        x.style.display = sold ? '' : 'none';
        btn.appendChild(x);

        const dp = (vFor && vFor.compare_at_price && Number(vFor.compare_at_price) > Number(vFor.price))
          ? discountPercent(vFor.price, vFor.compare_at_price)
          : 0;

        if(dp){
          const badge = document.createElement('span');
          badge.className = 'gwa-qb__badge gwa-qb__badge--sale';
          badge.textContent = dp + '%';
          btn.appendChild(badge);
        }

	        btn.addEventListener('mouseenter', ()=>{
	          const vv = vFor;
	          const src = vv ? (getVariantImageFromSwmap(swmap, vv.id) || (vv.featured_image && vv.featured_image.src) || '') : '';
	          if(src){
	            const pre = sizedShopifyImg(src, 240) || src;
	            preload(pre);
	          }
	        });

        btn.addEventListener('click', ()=>{
          state.selected[optName] = val;

          const names = getOptionNames(p);
          for(let i=0;i<names.length;i++){
            const on = names[i];
            if(on === optName) continue;
            if(state.selected[on] != null) continue;

            const vals = valuesByOpt[on] || [];
            if(vals.length) state.selected[on] = vals[0];
          }

          state.variant = findVariant(p, state.selected) || vFor || (p.variants ? p.variants[0] : null);
          updateUI();
        });

        grid.appendChild(btn);
      });

      wrap.appendChild(grid);
      elSwatches.appendChild(wrap);
    }

    state.variant = findVariant(p, state.selected) || (p.variants ? p.variants[0] : null);
    updateUI();
  }

  // Full swatch metadata is no longer inlined into every card; fetch it on demand.
  function loadSwatchMap(handle){
    if(swatchMapCache.has(handle)) return swatchMapCache.get(handle);
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const p = fetch(`${root}products/${handle}?view=swatch-map`, { credentials:'same-origin' })
      .then(r=>{
        if(!r.ok) throw new Error('Failed to load swatch map');
        return r.text();
      })
      .then(text=>JSON.parse(text))
      .catch(()=>{
        swatchMapCache.delete(handle);
        return null;
      });
    swatchMapCache.set(handle, p);
    return p;
  }

  async function loadProduct(handle){
    if(productCache.has(handle)) return productCache.get(handle);
    if(inflight.has(handle)) return inflight.get(handle);

    const p = fetch(`/products/${handle}.js`, { credentials:'same-origin' })
      .then(r=>{
        if(!r.ok) throw new Error('Failed to load product');
        return r.json();
      })
      .then(json=>{
        productCache.set(handle, json);
        inflight.delete(handle);
        return json;
      })
      .catch(e=>{
        inflight.delete(handle);
        throw e;
      });

    inflight.set(handle, p);
    return p;
  }

  function qtySet(n){
    state.qty = Math.max(1, Math.min(99, n|0));
    elQty.textContent = String(state.qty);
  }

  btnMinus.addEventListener('click', ()=>{
    if(btnMinus.disabled) return;
    qtySet(state.qty - 1);
  });
  btnPlus.addEventListener('click', ()=>{
    if(btnPlus.disabled) return;
    qtySet(state.qty + 1);
  });

  function getRoot(){
    return (window.Shopify && Shopify.routes && typeof Shopify.routes.root === 'string')
      ? Shopify.routes.root
      : '/';
  }
  function joinRoot(path){
    const base = getRoot();
    return (base.replace(/\/+$/,'/') + String(path||'').replace(/^\/+/,'')); 
  }

  function getCartDrawer(){
    return document.querySelector('cart-drawer');
  }

  function openDawnDrawer(){
    const drawer = getCartDrawer();
    if(drawer && typeof drawer.open === 'function'){
      drawer.open();
      return;
    }
    const bubble = document.getElementById('cart-icon-bubble');
    if(bubble) bubble.click();
  }

  function applyCartDrawerFromSectionHtml(sectionHtml){
    if(!sectionHtml) return;

    const drawer = getCartDrawer();
    if(!drawer) return;

    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');

    const freshDrawer = doc.querySelector('cart-drawer');
    const freshInner =
      doc.querySelector('cart-drawer .drawer__inner') ||
      doc.querySelector('#CartDrawer .drawer__inner') ||
      doc.querySelector('.drawer__inner');

    if(freshDrawer && freshDrawer.className){
      drawer.className = freshDrawer.className;
    }

    const curInner = drawer.querySelector('.drawer__inner');
    if(curInner && freshInner){
      curInner.innerHTML = freshInner.innerHTML;
    }
  }

  async function addToCartDawn(variantId, qty){
    const sections = ['cart-icon-bubble', 'cart-drawer'];
    const sectionsParam = encodeURIComponent(sections.join(','));
    const sectionsUrl = encodeURIComponent(window.location.pathname);

    const url = joinRoot(`cart/add.js?sections=${sectionsParam}&sections_url=${sectionsUrl}`);

    const fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', String(qty));

    const res = await fetch(url, {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });

    const json = await res.json().catch(()=> ({}));
    if(!res.ok){
      throw new Error(json && json.description ? json.description : 'cart add failed');
    }
    return json;
  }

  function applyBubbleFromSectionHtml(sectionHtml){
    if(!sectionHtml) return;

    const wrap = document.createElement('div');
    wrap.innerHTML = sectionHtml;

    const freshSection = wrap.querySelector('#shopify-section-cart-icon-bubble') || wrap.firstElementChild;
    const curSection = document.getElementById('shopify-section-cart-icon-bubble');

    if(freshSection && curSection){
      curSection.replaceWith(freshSection);
      return;
    }

    const freshBubble = wrap.querySelector('#cart-icon-bubble');
    const curBubble = document.getElementById('cart-icon-bubble');
    if(freshBubble && curBubble){
      curBubble.replaceWith(freshBubble);
    }
  }

  btnAdd.addEventListener('click', async ()=>{
    if(!state.variant || state.variant.available === false) return;

    btnAdd.disabled = true;

    try{
      const json = await addToCartDawn(state.variant.id, state.qty);
      close();

      if(json && json.sections){
        if(json.sections['cart-icon-bubble']){
          applyBubbleFromSectionHtml(json.sections['cart-icon-bubble']);
        }
        if(json.sections['cart-drawer']){
          applyCartDrawerFromSectionHtml(json.sections['cart-drawer']);
        }
      }

      const drawer = getCartDrawer();
      if(drawer && typeof drawer.renderContents === 'function'){
        try{ drawer.renderContents(json); }catch(e){}
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if(window.Shopify && typeof Shopify.onCartUpdate === 'function') Shopify.onCartUpdate();

      openDawnDrawer();
    }catch(e){
      btnAdd.disabled = false;
    }
  });

  document.addEventListener('click', async (e)=>{
    const btn = e.target && e.target.closest('[data-gwa-quickbuy]');
    if(!btn) return;

    const card = btn.closest('[data-product-card]');
    if(!card) return;

    const handle = card.getAttribute('data-product-handle');
    if(!handle) return;

    state.card = card;
    state.swmap = parseSwMap(card);
    state.selected = {};
    qtySet(1);
    setImageFromVariantOrProduct(null, null);

    open();

    try{
      const [p, fetchedSwMap] = await Promise.all([loadProduct(handle), loadSwatchMap(handle)]);
      if(state.card !== card) return;
      state.product = p;
      if(fetchedSwMap) state.swmap = parseSwMap(card, fetchedSwMap);

      elTitle.textContent = p.title || '';
      const sub = card.querySelector('.card__subtitle');
      elSub.textContent = sub ? (sub.textContent || '').trim() : '';

	      const initialVariantId = card.getAttribute('data-initial-variant-id');
	      state.variant = (p.variants || []).find(v => String(v.id) === String(initialVariantId)) || ((p.variants && p.variants[0]) ? p.variants[0] : null);
	      const optionNames = getOptionNames(p);
	      if(state.variant){
	        optionNames.forEach((name, idx)=>{
	          const value = (state.variant.options || [])[idx];
	          if(value != null) state.selected[name] = value;
	        });
	      }
	      setImageFromVariantOrProduct(state.variant, p);
	      renderSwatches();
    }catch(err){
      close();
      // Keep the product reachable when the optional quick-buy request fails.
      const productUrl = btn.getAttribute('data-product-url');
      if(productUrl){
        const url = new URL(productUrl, window.location.href);
        if(url.origin === window.location.origin) window.location.assign(url.href);
      }
    }
  });
  window.__GwaQuickbuyReady = true;
})();
